import chooseYourBoxIcon from './assets/choose_your_box_icon.png'
import chooseYourDeliveryDateIcon from './assets/choose_your_delivery_date_icon.png'
import createYourAccountIcon from './assets/create_your_account_icon.png'
import enterYourPostCodeIcon from './assets/enter_your_postcode_icon.png'
import pickYourRecipesIcon from './assets/pick_your_recipes_icon.png'
import {
  trackClickBoxSizeExplanationBox,
  trackClickPostcodeExplanationBox,
  trackClickDeliveryDateExplanationBox,
  trackClickPickYourRecipesExplanationBox,
  trackClickCreateAccountExplanationBox,
} from './snowplowActions'

export const pageTitle = 'Your recipes are just a few steps away...'

export enum ExplanationBoxType {
  CHOOSE_YOUR_BOX,
  ENTER_YOUR_POSTCODE,
  CHOOSE_YOUR_DELIVERY_DATE,
  PICK_YOUR_RECIPES,
  CREATE_YOUR_ACCOUNT,
}

export type ExplanationBoxData = {
  title: string
  icon: string
  text: string
  type: ExplanationBoxType
  trackingAction: () => (dispatch: any, getState: any) => void
}

const chooseYourBoxBlock: ExplanationBoxData = {
  title: 'Choose your box size',
  icon: chooseYourBoxIcon,
  text: 'Pick a regular or large box to suit your household.',
  type: ExplanationBoxType.CHOOSE_YOUR_BOX,
  trackingAction: trackClickBoxSizeExplanationBox,
}

const enterYourPostCodeBlock: ExplanationBoxData = {
  title: 'Enter your postcode',
  icon: enterYourPostCodeIcon,
  text: 'We’ll find the next available delivery date in your area.',
  type: ExplanationBoxType.ENTER_YOUR_POSTCODE,
  trackingAction: trackClickPostcodeExplanationBox,
}

const chooseYourDeliveryDateBlock: ExplanationBoxData = {
  title: 'Choose your delivery date',
  icon: chooseYourDeliveryDateIcon,
  text: 'Tell us when you’d like us to deliver your first box.',
  type: ExplanationBoxType.CHOOSE_YOUR_DELIVERY_DATE,
  trackingAction: trackClickDeliveryDateExplanationBox,
}

const pickYourRecipesBlock: ExplanationBoxData = {
  title: 'Pick your recipes',
  icon: pickYourRecipesIcon,
  text: 'Choose 2 or more recipes from over 75 mouthwatering meals.',
  type: ExplanationBoxType.PICK_YOUR_RECIPES,
  trackingAction: trackClickPickYourRecipesExplanationBox,
}

const createYourAccountBlock: ExplanationBoxData = {
  title: 'Create your account',
  icon: createYourAccountIcon,
  text: 'Pop in your payment details and place your first order.',
  type: ExplanationBoxType.CREATE_YOUR_ACCOUNT,
  trackingAction: trackClickCreateAccountExplanationBox,
}

export const blockData = [
  chooseYourBoxBlock,
  enterYourPostCodeBlock,
  chooseYourDeliveryDateBlock,
  pickYourRecipesBlock,
  createYourAccountBlock,
]

export const nextStepCTA = 'Choose my box size'
